<template>
  <div>
    <!-- 面包屑组件 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/welcome' }">主页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/studentList'}">在读学员</el-breadcrumb-item>
      <el-breadcrumb-item>更新学员</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 内容卡片 -->
    <el-card>
      <div slot="header" class="clearfix">
        <span>{{isEdit?'更新':'新增'}}在读学员</span>
      </div>
      <div>
        <el-form label-width="160px" :rules="rules" ref="fromData" :model="fromData" >
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="学员姓名" prop="realname">
                <el-input v-model="fromData.realname"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号码" prop="phone">
                <el-input v-model="fromData.phone"></el-input>
              </el-form-item>
            </el-col>
           </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="年级" prop="grade">
                <el-select v-model="fromData.grade" placeholder="请选择">
                  <el-option
                    v-for="item in gradeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>

              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="科目" prop="subject">
                <el-select multiple v-model="fromData.subject" placeholder="请选择">
                  <el-option
                    v-for="item in subjectList"
                    :key="item.name"
                    :label="item.name"
                    :value="item.name">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="学管师" prop="followUpPersonId">
                <el-select v-model="fromData.followUpPersonId" placeholder="请选择">
                  <el-option
                    v-for="item in teacherList"
                    :key="item.id"
                    :label="item.realname"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="性别" prop="sex">
                <el-radio v-model="fromData.sex" :label="1">男</el-radio>
                <el-radio v-model="fromData.sex" :label="2">女</el-radio>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="学员生日" prop="birthday">
                <el-date-picker
                  v-model="fromData.birthday"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="就读学校" prop="school">
                <el-input v-model="fromData.school"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="家庭住址" prop="homeAddress">
                <el-input v-model="fromData.homeAddress"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
           <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="紧急联系人" prop="emergencyContact">
                <el-input v-model="fromData.emergencyContact"></el-input>
              </el-form-item>
            </el-col>
             <el-col :span="12">
               <el-form-item label="紧急人电话" prop="emergencyContactPhone">
                 <el-input v-model="fromData.emergencyContactPhone"></el-input>
               </el-form-item>
             </el-col>
           </el-row>
        </el-form>
      </div>
    </el-card>

    <div class="footer-nav">
          <el-button type="primary" @click="submitForm('fromData')">确定</el-button>
          <el-button @click="resetForm('fromData')">取消</el-button>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        id:'',
        fromData:{
          birthda:'',
          createTime:'',
          emergencyContact:'',
          emergencyContactPhone:'',
          followUpPersonId:'',
          grade:'',
          reminderTimes: 0,
          reminderHours: 0,
          homeAddress:'',
          id:'',
          phone:'',
          realname:'',
          recommender:'',
          remark:'',
          school:'',
          sex:0,
          updateTime:'',
        },
        // 学管师列表
        teacherList:[],
        gradeList: [{id: 2,name: '二年级'},
          {id: 3,name: '三年级'},
          {id: 4,name: '四年级'},
          {id: 5,name: '五年级'},
          {id: 6,name: '六年级'},
          {id: 7,name: '七年级'},
          {id: 8,name: '八年级'},
          {id: 9,name: '九年级'},
          {id: 10,name: '高一'},
          {id: 11,name: '高二'},
          {id: 12,name: '高三'}],
        subjectList: [{id: 1,name: '数学'},
          {id: 2,name: '语文'},
          {id: 3,name: '英语'},
          {id: 4,name: '科学'},
          {id: 5,name: '物理'},
          {id: 6,name: '化学'},
          {id: 7,name: '生物'}],
        isEdit: false,
        // 校验规则
        rules: {
          realname: [
            { required: true, message: '请输入学生姓名', trigger: 'blur' }
          ],
          phone: [
            { required: true, message: '请输入手机号码', trigger: 'blur' }
          ],
          grade: [
            { required: true, message: '请选择年级', trigger: 'blur' }
          ],
          followUpPersonId: [
            { required: true, message: '请选择学管师', trigger: 'blur' }
          ],
        }
      };
    },
    created() {
      this.getTeacherList();
      this.initData();
    },
    methods: {
      async addStudent() {
        this.fromData.subject = this.fromData.subject?this.fromData.subject.join(","):'';
        const { data: res } = await this.$http.post(this.isEdit?"/ea/student/student/edit":"/ea/student/student/add",this.fromData);
        if (res.code !== 200) return this.$message.error(res.message);
        this.$message.success(this.isEdit?"更新成功":"新增成功");
        this.$router.push({
            path: '/studentList',
        })
      },
      initData() {
        let params = this.$route.params;
        if(params && params.type=='edit'){
          this.fromData = params.recordDate
          this.fromData.subject = this.fromData.subject?this.fromData.subject.split(","):[];
          this.isEdit = true;
        }
      },
      async getTeacherList() {
        const { data: res } = await this.$http.get(`/ea/sys/user/getTeacherManagerList`);
        if (res.code !== 200)
          return this.$message.error(res.message);
        this.teacherList = res.result;
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.addStudent();
          } else {
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.$router.push("/studentList");
      }
  },
};
</script>

<style lang="less" scoped>
  /deep/ .el-upload__input{
    display: none;
  }
</style>
